import { AbstractControl, ValidationErrors } from '@angular/forms';

export const phoneValidator = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value || '';
  if (!value.trim()) return null;
  const rawValue = value.replace(/\D/g, '');
  return rawValue.length < 9 ? { phone_invalid_length: true } : null;
};
